import * as React from "react";
import isElectron from "is-electron";
import styled from "styled-components";
import { Link, useHistory } from "react-router-dom";
import { ENVSETTINGKEY, LOGININFOSTORE, LOGINTOKEN } from "@/config/const";
import { Radio } from "antd";
import { storage } from "@/util";

const Container = styled.div`
  padding: 60px 60px 0 20px;
  .item {
    padding: 10px 0;
  }
`;

const EnvSetting: React.FunctionComponent = () => {
  const history = useHistory();
  const aenv = storage.get(ENVSETTINGKEY) || "online";
  const [env, setEnv] = React.useState(aenv);

  const options = [
    { label: "Тестийн орчин", value: "test" },
    { label: "Production орчин", value: "online" },
  ];

  const changeHandler = (e: any) => {
    const v = e.target.value;
    setEnv(v);
    storage.save(ENVSETTINGKEY, v);
    storage.remove(LOGININFOSTORE);
    storage.remove(LOGINTOKEN);
    if(isElectron()){
      alert(`${v=="online"?`Test`:`Production`} орчин руу шилжүүлэх`);
      history.replace("/");
    }else{
      window.location.href = "/";
    }
    //window.location.href = "/";
    //history.replace("/");
  };

  return (
    <Container className="f1">
      <p className="mb20 mt20">Environment тохируулах</p>

      <Radio.Group
        options={options}
        onChange={changeHandler}
        value={env}
        optionType="button"
        buttonStyle="solid"
      />
    </Container>
  );
};

export default EnvSetting;
